module.exports = __webpack_public_path__ + "static/media/IMG_3543.0625ae70.jpg";